export const formatStrings = {
    // Full & Common Date Formats
    FULL_DATE: 'EEEE, MMMM do, yyyy',               // Saturday, October 7th, 2024
    SHORT_DATE: 'dd/MM/yyyy',                       // 07/10/2024
    MEDIUM_DATE: 'do MMM, yyyy',                    // 7th Oct, 2024
    LONG_DATE: 'do MMMM, yyyy',                     // 7th October, 2024
    ISO_DATE: 'yyyy-MM-dd',                         // 2024-10-07
    ISO_DATE_TIME: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",  // 2024-10-07T14:45:30.123+00:00

    // Time Formats
    TIME_24_HOUR: 'HH:mm:ss',                       // 14:45:30
    TIME_24_HOUR_SHORT: 'HH:mm',                    // 14:45
    TIME_12_HOUR: 'hh:mm a',                        // 02:45 PM
    TIME_12_HOUR_WITH_SECONDS: 'hh:mm:ss a',        // 02:45:30 PM

    // Combined Date & Time
    DATE_TIME_24H: 'dd/MM/yyyy HH:mm',              // 07/10/2024 14:45
    DATE_TIME_12H: 'dd/MM/yyyy hh:mm a',            // 07/10/2024 02:45 PM
    LONG_DATE_TIME: 'EEEE, do MMMM yyyy, HH:mm',    // Saturday, 7th October 2024, 14:45

    // Week, Month, Year
    DAY_MONTH_YEAR: 'dd-MM-yyyy',                   // 07-10-2024
    MONTH_YEAR: 'MMMM yyyy',                        // October 2024
    MONTH_SHORT_YEAR: 'MMM yy',                     // Oct 24
    MONTH_NUMERIC_YEAR: 'MM/yyyy',                  // 10/2024
    YEAR_FULL: 'yyyy',                              // 2024
    YEAR_SHORT: 'yy',                               // 24
    WEEK_NUMBER: 'wo [week]',                       // 41st week
    DAY_OF_YEAR: 'DDD',                             // 280 (day of year)

    // Weekday formats
    WEEKDAY_SHORT: 'EEE',                           // Mon
    WEEKDAY_MEDIUM: 'EEEE, MMM do',                 // Monday, Oct 7th
    WEEKDAY_FULL: 'EEEE',                           // Monday

    // Month Formats
    MONTH_SHORT: 'MMM',                             // Oct
    MONTH_FULL: 'MMMM',                             // October
    MONTH_NUMERIC: 'MM',                            // 10

    // Miscellaneous
    FILE_NAME_TIMESTAMP: "yyyyMMdd_HHmmss",         // 20241007_144530
    LOG_TIMESTAMP: "yyyy-MM-dd HH:mm:ss",           // 2024-10-07 14:45:30
    HUMAN_READABLE: "do MMMM yyyy 'at' hh:mm a",    // 7th October 2024 at 02:45 PM
    CHAT_TIMESTAMP: 'hh:mm a | dd MMM',             // 02:45 PM | 07 Oct
    INPUT_DATE: 'yyyy-MM-dd',                       // 2024-10-07 (for HTML inputs)
    INPUT_TIME: 'HH:mm',                            // 14:45 (for HTML inputs)
    SHORT_MONTH_DAY: 'MMM d',                       // Oct 7
    FULL_MONTH_DAY: 'MMMM do',                      // October 7th
} as const;


export type DateFormatStringType = keyof typeof formatStrings;